import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4d8ecee3"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "column field" };
const _hoisted_2 = { style: { "display": "flex" } };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Locations *", -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mb-2" }, "Please enter the names of any locations (e.g. shelters or branch offices) where you would like citizens to be able to make use of Mini City services. These should be simple, recognisable names which citizens and employees will select from when using Mini City services - such as 'Atlanta Downtown' or 'Birch Street Shelter'", -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("ul", null, [
    /*#__PURE__*/ _createElementVNode("li", null, "- At least one location is required"),
    /*#__PURE__*/ _createElementVNode("li", null, "- If your organization operates remotely / online, you can enter 'Virtual' as a location name")
], -1));
const _hoisted_6 = { class: "control mt-2" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1));
const _hoisted_8 = { class: "mt-2 horizontal" };
const _hoisted_9 = { class: "tag is-light is-rounded has-text-weight-bold" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-home fa-lg mr-3" }, null, -1));
const _hoisted_11 = { class: "badgeLabel" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
    key: 0,
    class: "list-group-item"
};
import { ref, onMounted } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LocationListField',
    props: {
        modelValue: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const locations = ref([]);
        const locationToAdd = ref("");
        // Event for two-way binding
        const emit = __emit;
        const onInput = () => {
            emit('update:modelValue', locations.value);
        };
        onMounted(() => {
            locations.value = props.modelValue;
        });
        const addNewLocation = () => {
            if (locationToAdd.value.length > 0 && !locations.value.includes(locationToAdd.value)) {
                locations.value.push(locationToAdd.value);
                locationToAdd.value = "";
                onInput();
            }
        };
        const deleteLocation = (idx) => {
            locations.value.splice(idx, 1);
            onInput();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _renderSlot(_ctx.$slots, "top")
                ]),
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                        class: "input",
                        style: { "max-width": "50%" },
                        type: "text",
                        placeholder: "Please enter location",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((locationToAdd).value = $event))
                    }, null, 512), [
                        [
                            _vModelText,
                            locationToAdd.value,
                            void 0,
                            { trim: true }
                        ]
                    ]),
                    _createElementVNode("button", {
                        type: "submit",
                        value: "Save",
                        class: "button is-link is-small ml-1",
                        onClick: addNewLocation
                    }, [
                        _hoisted_7,
                        _createTextVNode(" Add ")
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (locationName, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: "mr-2"
                            }, [
                                _createElementVNode("span", _hoisted_9, [
                                    _hoisted_10,
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(locationName), 1),
                                    _createElementVNode("span", {
                                        class: "delete ml-2",
                                        role: "button",
                                        onClick: ($event) => (deleteLocation(idx))
                                    }, "(x)", 8, _hoisted_12)
                                ])
                            ]));
                        }), 128)),
                        (locations.value.length == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, "There are no Locations added yet."))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
